export default () =>
  typeof window !== 'undefined' &&
  ('ontouchstart' in window || 'onmsgesturechange' in window);
